import camelCase from 'lodash/camelCase';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { servicedeskPlaybooksListOnlyRoute } from '@atlassian/jira-router-routes-project-settings-playbooks-routes/src/servicedeskPlaybooksListOnlyRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { SIDEBAR_ID, MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import playbookListOnlyEntryPoint from '@atlassian/jira-spa-apps-project-settings-playbooks-list-only-view/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { playbooksListRequestTypesResource } from '@atlassian/jira-playbooks-list-screen-router-resources/src/services/index.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { isFedRamp } from '@atlassian/atl-context';
import playbooksHorizontalNavEntrypoint from '@atlassian/jira-spa-apps-project-settings-playbooks-horizontal-nav/entrypoint.tsx';
import { PlaybookWrappedListLoadingView as PlaybookListLoadingView } from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-list/edge-cases/PlaybookListLoadingView.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const listOnlyEntryPoint = createPageEntryPoint({
	main: playbookListOnlyEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: playbooksHorizontalNavEntrypoint,
});

export const servicedeskPlaybooksListOnlyRouteEntry = createEntry(
	servicedeskPlaybooksListOnlyRoute,
	// eslint-disable-next-line jira/route-definitions/entry-standards
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},
		entryPoint() {
			if (isFedRamp() || !fg('phantom-3633-playbook-routes-migration')) {
				return notFoundPageEntrypoint;
			}
			return listOnlyEntryPoint;
		},
		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			playbooksListRequestTypesResource,
		],
		meta: {
			reporting: {
				id: 'project-settings.playbooks.list-only-view',
				packageName: camelCase('project-settings-playbooks-list-only'),
				teamName: 'ITOps Phantom',
			},
		},
		component: ErrorPagesNotFound,
		ufoName: 'playbook-list-only',
		skeleton: PlaybookListLoadingView,
	}),
);
